import { SVGProps, Ref, forwardRef } from "react";

const ThreeDotsVerticalIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 4 16"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Three Dots Vertical Icon"
    {...props}
  >
    <title id="Three Dots Vertical Icon">Three Dots Vertical Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2 8.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666ZM2 3a.833.833 0 1 0 0-1.667A.833.833 0 0 0 2 3Zm0 11.667A.833.833 0 1 0 2 13a.833.833 0 0 0 0 1.667Z"
    />
  </svg>
);

const ForwardRef = forwardRef(ThreeDotsVerticalIcon);
export default ForwardRef;
